// // ================= MULTIPLE FREE GIFTS =================
// (function() {
//   'use strict';

//   // ── Alert suppression ─────────────────────────────────────────────────────
//   const _originalAlert = window.alert;
//   let _suppressAlert = false;

//   window.alert = function(msg) {
//     // Always block "X items in cart" alerts (theme noise)
//     if (typeof msg === 'string' &&
//         /there are now \d+ items? in the cart/i.test(msg)) {
//       console.log('[GiftSystem] Blocked cart count alert:', msg);
//       return;
//     }

//     // Block ALL alerts during our gift operations
//     if (_suppressAlert) {
//       console.log('[GiftSystem] Suppressed alert during gift op:', msg);
//       return;
//     }

//     return _originalAlert.apply(this, arguments);
//   };

//   const HERBAL_TEA_PRODUCTS = [
//     8859134197978, 8859126857946, 8859136950490,
//     8859138556122, 8859130298586
//   ];

//   const GREEN_TEA_PRODUCTS = [
//     8182944104666, 8182952984794, 8182940172506, 
//     8182953705690, 8182947086554, 8182944858330, 
//     8182943351002, 8290704163034, 8182954492122,
//     8182954819802, 8183066624218, 8183103455450,
//     8183104504026, 8183105355994, 8183065280730,
//     8182945415386, 8182946529498
//   ];

//   const FREE_GIFT_BUNDLES = [
//     {
//       id: 'bundle-1',
//       requires: [{ productId: 8183095460058, qty: 3 }],
//       gifts: [{ productId: 9285847187674, qty: 2 }]
//     },
//     {
//       id: 'bundle-2',
//       requires: [
//         { productId: 8183095460058, qty: 1 },
//         { productId: 8183072882906, qty: 1 },
//         { greenTea: true, qty: 1 },
//         { herbalTea: true, qty: 1 }
//       ],
//       gifts: [{ productId: 9285847187674, qty: 1 }]
//     },
//     {
//       id: 'bundle-3',
//       requires: [
//         { productId: 8183089987802, qty: 1 },
//         { productId: 8183072882906, qty: 1 },
//         { greenTea: true, qty: 1 },
//         { herbalTea: true, qty: 1 }
//       ],
//       gifts: [{ productId: 9285847187674, qty: 1 }]
//     },
//     {
//       id: 'bundle-4',
//       requires: [
//         { productId: 8183072882906, qty: 2 },
//         { herbalTea: true, qty: 2 }
//       ],
//       gifts: [{ productId: 9285844893914, qty: 1 }]
//     }
//   ];

//   const productVariantCache = {};
//   let isUpdatingGift = false;
//   let pendingUpdate = false;
//   let giftUpdateTimer = null;
//   let _ownCartCall = false;

//   if (typeof window.correctGiftSubtotal !== 'function') {
//     window.correctGiftSubtotal = function() {};
//   }

//   function sleep(ms) {
//     return new Promise(resolve => setTimeout(resolve, ms));
//   }

//   function triggerGiftUpdate(delay = 300) {
//     toggleCheckoutButton(true);
//     clearTimeout(giftUpdateTimer);
//     giftUpdateTimer = setTimeout(() => {
//       updateMultipleFreeGifts();
//     }, delay);
//   }

//   async function resolveVariantId(productId) {
//     if (productVariantCache[productId]) return productVariantCache[productId];

//     try {
//       let page = 1;
//       while (true) {
//         const data = await fetch(`/products.json?limit=250&page=${page}`)
//           .then(r => r.json());

//         if (!data.products || data.products.length === 0) break;

//         for (const p of data.products) {
//           if (p.id === productId) {
//             productVariantCache[productId] = p.variants[0].id;
//             return p.variants[0].id;
//           }
//         }

//         if (data.products.length < 250) break;
//         page++;
//       }
//     } catch (e) {
//       console.warn(`resolveVariantId failed for ${productId}`, e);
//     }
//     return null;
//   }

//   async function preCacheGiftVariants() {
//     const allGiftProductIds = FREE_GIFT_BUNDLES.flatMap(b => b.gifts.map(g => g.productId));
//     await Promise.all(allGiftProductIds.map(id => resolveVariantId(id)));
//   }

//   function isBundleQualified(bundle, cartItems) {
//     for (const req of bundle.requires) {

//       if (req.herbalTea) {
//         const herbalTeaQty = cartItems
//           .filter(item =>
//             HERBAL_TEA_PRODUCTS.includes(item.product_id) &&
//             !(item.properties && item.properties._freeGift === 'true')
//           )
//           .reduce((sum, item) => sum + item.quantity, 0);

//         if (herbalTeaQty < req.qty) return false;
//         continue;
//       }

//       if (req.greenTea) {
//         const greenTeaQty = cartItems
//           .filter(item =>
//             GREEN_TEA_PRODUCTS.includes(item.product_id) &&
//             !(item.properties && item.properties._freeGift === 'true')
//           )
//           .reduce((sum, item) => sum + item.quantity, 0);

//         if (greenTeaQty < req.qty) return false;
//         continue;
//       }

//       const cartQty = cartItems
//         .filter(item =>
//           item.product_id === req.productId &&
//           !(item.properties && item.properties._freeGift === 'true')
//         )
//         .reduce((sum, item) => sum + item.quantity, 0);

//       if (cartQty < req.qty) return false;
//     }

//     return true;
//   }

//   async function fetchCartWithRetry(maxRetries = 3, delayMs = 200) {
//     for (let i = 0; i < maxRetries; i++) {
//       try {
//         const cart = await fetch('/cart.js', {
//           cache: 'no-store',
//           headers: { 'Cache-Control': 'no-cache' }
//         }).then(r => r.json());
//         return cart;
//       } catch (e) {
//         if (i === maxRetries - 1) throw e;
//         await sleep(delayMs);
//       }
//     }
//   }

//   function toggleCheckoutButton(disabled = true) {
//     const selectors = [
//       'button[name="checkout"]',
//       '.cart__checkout-button',
//       '.button-checkout',
//       '.checkout-button',
//       '[data-checkout-button]',
//       'input[name="checkout"]'
//     ];

//     selectors.forEach(selector => {
//       document.querySelectorAll(selector).forEach(btn => {
//         btn.disabled = disabled;
//         btn.style.pointerEvents = disabled ? 'none' : '';
//         btn.style.opacity = disabled ? '0.5' : '';
//         btn.classList.toggle('loading', disabled);

//         if (disabled) {
//           btn.dataset.originalText = btn.innerHTML;
//           btn.innerHTML = 'Proceed To Checkout';
//         } else if (btn.dataset.originalText) {
//           btn.innerHTML = btn.dataset.originalText;
//         }
//       });
//     });
//   }

//   async function updateMultipleFreeGifts() {
//     if (isUpdatingGift) {
//       pendingUpdate = true;
//       return;
//     }

//     isUpdatingGift = true;
//     pendingUpdate = false;
//     toggleCheckoutButton(true); // Disable checkout
//     let cartChanged = false;

//     try {
//       await sleep(250);

//       const cart = await fetchCartWithRetry();

//       console.log('[GiftSystem] Cart items:', cart.items.map(i => ({
//         product_id: i.product_id,
//         qty: i.quantity,
//         isFreeGift: i.properties && i.properties._freeGift
//       })));

//       const operations = [];

//       for (const bundle of FREE_GIFT_BUNDLES) {
//         const qualified = isBundleQualified(bundle, cart.items);

//         console.log(`[GiftSystem] Bundle ${bundle.id} qualified:`, qualified);

//         for (const gift of bundle.gifts) {
//           const existingGift = cart.items.find(item =>
//             item.product_id === gift.productId &&
//             item.properties &&
//             item.properties._freeGift === 'true' &&
//             item.properties._bundleId === bundle.id
//           );

//           if (qualified && !existingGift) {
//             operations.push({ type: 'add', bundle, gift });
//           } else if (!qualified && existingGift) {
//             operations.push({ type: 'remove', existingGift });
//           } else if (qualified && existingGift && existingGift.quantity !== gift.qty) {
//             operations.push({ type: 'update', existingGift, gift });
//           }
//         }
//       }

//       if (operations.length > 0) {
//         _ownCartCall = true;
//         _suppressAlert = true;
        
//         try {
//           for (const op of operations) {

//             if (op.type === 'add') {
//               const variantId = await resolveVariantId(op.gift.productId);
//               if (!variantId) continue;

//               console.log(`[GiftSystem] Adding gift for bundle ${op.bundle.id}`);

//               const res = await fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                   id: variantId,
//                   quantity: op.gift.qty,
//                   properties: {
//                     _freeGift: 'true',
//                     _bundleId: op.bundle.id
//                   }
//                 })
//               });

//               if (res.ok) cartChanged = true;

//             } else if (op.type === 'remove') {
//               console.log(`[GiftSystem] Removing gift key ${op.existingGift.key}`);

//               const res = await fetch('/cart/change.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                   id: op.existingGift.key,
//                   quantity: 0
//                 })
//               });

//               if (res.ok) cartChanged = true;

//             } else if (op.type === 'update') {
//               console.log(`[GiftSystem] Updating gift qty for key ${op.existingGift.key}`);

//               const res = await fetch('/cart/change.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                   id: op.existingGift.key,
//                   quantity: op.gift.qty
//                 })
//               });

//               if (res.ok) cartChanged = true;
//             }
//           }
//         } finally {
//           _ownCartCall = false;
//           setTimeout(() => { _suppressAlert = false; }, 2000);
//         }
//       }

//     } catch (e) {
//       console.error('[GiftSystem] Gift update error:', e);
//       _ownCartCall = false;
//     } finally {
//   isUpdatingGift = false;
//   if (!pendingUpdate) {
//     toggleCheckoutButton(false); // tabhi enable karo jab sab clear ho
//   }
// }

//     if (cartChanged) {
//       try {
//         await refreshCartUI();
//       } catch (e) {
//         console.error('[GiftSystem] refreshCartUI threw:', e);
//       }
//     } else {
//       try {
//         applyFreeGiftPriceDisplay();
//       } catch (e) {}
//     }

//     if (pendingUpdate) {
//       triggerGiftUpdate(100);
//     }
//   }

//   // ── Refresh cart UI ─────────────────────────────────────────────────────
//   async function refreshCartUI() {
//     try {
//       await sleep(500);
    
//       const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
    
//       console.log('[GiftSystem] Cart state BEFORE UI refresh:', {
//         itemCount: cart.item_count,
//         total: cart.total_price,
//         items: cart.items.map(i => ({
//           product_id: i.product_id,
//           qty: i.quantity,
//           isFreeGift: i.properties && i.properties._freeGift
//         }))
//       });
    
//       // ── ON CART PAGE: RELOAD (only reliable option) ────────────────────
//       if (document.body.classList.contains('template-cart') ||
//           window.location.pathname === '/cart' ||
//           window.location.pathname === '/cart/') {
//         console.log('[GiftSystem] On cart page — reloading');
//         window.location.reload();
//         return;
//       }
    
//       // ── ON OTHER PAGES: Refresh drawer directly ────────────────────────
//       _ownCartCall = true;
//       await refreshDrawerHTML();
//       _ownCartCall = false;
    
//       // Update cart count badges everywhere
//       document.querySelectorAll(
//         '[data-cart-count], .cart-count, .cart__count, ' +
//         '.header__cart-count, .cart-link__bubble, .cart-icon-bubble'
//       ).forEach(el => {
//         el.textContent = cart.item_count;
//       });
    
//       applyFreeGiftPriceDisplay();
    
//       [300, 700, 1500].forEach(delay => {
//         setTimeout(applyFreeGiftPriceDisplay, delay);
//       });
    
//       // Fire Shopify's cart update callback (some apps listen for this)
//       try {
//         if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
//           window.Shopify.onCartUpdate(cart);
//         }
//       } catch (e) {}
    
//     } catch (e) {
//       console.error('[GiftSystem] refreshCartUI error:', e);
//       _ownCartCall = false;
//     }
//   }
  
//   // ── Refresh drawer by fetching native endpoint ────────────────────────────
//   async function refreshDrawerHTML() {
//     try {
//       const ts = Date.now();
    
//       const html = await fetch(`/cart?view=ajax_side_cart&_=${ts}`, {
//         cache: 'no-store',
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest',
//           'Cache-Control': 'no-cache, no-store, must-revalidate',
//           'Pragma': 'no-cache'
//         }
//       }).then(r => r.text());
    
//       if (!html || !html.trim()) {
//         console.warn('[GiftSystem] Empty drawer HTML');
//         return false;
//       }
    
//       // The theme replaces this EXACT selector (from theme code we saw):
//       // #halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper
//       const target = document.querySelector(
//         '#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper'
//       );
    
//       if (target) {
//         target.innerHTML = html;
//         console.log('[GiftSystem] .previewCart-wrapper updated (full path)');
//         return true;
//       }
    
//       // Fallbacks if path slightly different
//       const fallbacks = [
//         '.previewCart-wrapper',
//         '#halo-cart-sidebar .halo-sidebar-wrapper',
//         '#halo-cart-sidebar'
//       ];
    
//       for (const sel of fallbacks) {
//         const el = document.querySelector(sel);
//         if (el) {
//           el.innerHTML = html;
//           console.log(`[GiftSystem] Drawer updated via: ${sel}`);
//           return true;
//         }
//       }
    
//       console.warn('[GiftSystem] No drawer target found');
//       return false;
    
//     } catch (e) {
//       console.warn('[GiftSystem] refreshDrawerHTML failed:', e);
//       return false;
//     }
//   }

//   // ── Apply FREE display ──────────────────────────────────────────────────
//   function applyFreeGiftPriceDisplay() {
//     document.querySelectorAll(
//       '.cart-item, .ajaxcart__product, .mini_cart_item, ' +
//       '.previewCartItem, div.cart-item'
//     ).forEach(itemEl => {
//       let isFreeGift = false;

//       const propsEl = itemEl.querySelector('[data-properties]');
//       if (propsEl) {
//         try {
//           const parsed = JSON.parse(propsEl.dataset.properties);
//           if (parsed._freeGift === 'true') isFreeGift = true;
//         } catch (_) {}
//       }

//       if (!isFreeGift) {
//         itemEl.querySelectorAll('*').forEach(el => {
//           if (el.children.length === 0 && el.textContent.includes('_freeGift')) {
//             isFreeGift = true;
//           }
//         });
//       }

//       if (!isFreeGift) return;

//       // Hide property rows
//       itemEl.querySelectorAll('*').forEach(el => {
//         const text = el.textContent.trim();
//         if (
//           el.children.length === 0 &&
//           (text === '_freeGift' || text === 'true' ||
//            text === '_bundleId' || text.startsWith('bundle-'))
//         ) {
//           const row = el.closest(
//             'tr, li, p, .property, div.property, ' +
//             '.cart-item__property, .product-details__item--property, ' +
//             '.ajaxcart__property, .cart-item__properties, .item-properties, ' +
//             '.previewCartItem-variant'
//           );
//           if (row) row.style.display = 'none';
//         }
//       });

//       // Hide price
//       [
//         '.cart-item__price', '.ajaxcart__price', '.price', '.cart__price',
//         '.money', '[data-cart-item-price]', '.cart-item__final-price',
//         '.item-price', '.ajaxcart__product-price', '.cart-item__line-price',
//         '.cart-item__total', '.line-price', '.previewCartItem-price',
//         '.previewCartItem-total'
//       ].forEach(sel => {
//         itemEl.querySelectorAll(sel).forEach(priceEl => {
//           if (!priceEl.classList.contains('free-gift-price')) {
//             priceEl.style.display = 'none';
//           }
//         });
//       });

//       itemEl.querySelectorAll('.free-gift-price, .free-gift-badge').forEach(el => el.remove());

//       // Inject Free Gift badge
//       const titleEl = itemEl.querySelector(
//         '.cart-item__name, .ajaxcart__product-name, .item-name, ' +
//         '.cart-item__title, a.cart__product-title, .ajaxcart__product-title, ' +
//         '.cart-item__product-title, .previewCartItem-name, ' +
//         '.previewCartItem-title, h2, h3, h4'
//       );

//       if (titleEl) {
//         const badge = document.createElement('span');
//         badge.className = 'free-gift-badge';
//         badge.innerHTML = '🎁 Free Gift';
//         badge.style.cssText = `
//           display:inline-block;background:#e74c3c;color:#fff;
//           font-size:10px;font-weight:700;padding:2px 7px;
//           border-radius:3px;margin-left:6px;letter-spacing:0.4px;
//           vertical-align:middle;
//         `;
//         titleEl.appendChild(badge);
//       }

//       // Inject FREE label
//       const priceParent = itemEl.querySelector(
//         '.cart-item__price, .ajaxcart__price, .ajaxcart__product-price, ' +
//         '.price, .item-price, [data-cart-item-price], .cart-item__total, ' +
//         '.line-price, .cart-item__line-price, .previewCartItem-price, ' +
//         '.previewCartItem-total'
//       );

//       if (priceParent) {
//         const freeTag = document.createElement('span');
//         freeTag.className = 'free-gift-price';
//         freeTag.textContent = 'FREE';
//         freeTag.style.cssText = `
//           color:#27ae60;font-weight:700;font-size:13px;
//           letter-spacing:0.5px;display:inline-block;
//         `;
//         priceParent.parentNode.insertBefore(freeTag, priceParent.nextSibling);
//       }

//       // Disable qty controls
//       itemEl.querySelectorAll(
//         'input.item-quantity, input[name="updates[]"], .ajaxcart__qty-adjust, ' +
//         '.quantity__button, [data-quantity-plus], [data-quantity-minus], ' +
//         '.btn-quantity, input.quantity, .quantity input, ' +
//         '[data-cart-quantity], input[data-cart-quantity]'
//       ).forEach(ctrl => {
//         ctrl.disabled = true;
//         ctrl.style.pointerEvents = 'none';
//         ctrl.style.opacity = '0.4';
//       });

//       // Hide remove buttons
//       itemEl.querySelectorAll(
//         '.ajaxcart__product-remove, .cart-item__remove, ' +
//         '[data-remove-item], .remove-item, a.cart__remove, ' +
//         '[data-cart-remove], .cart-item__remove-btn'
//       ).forEach(btn => { btn.style.display = 'none'; });
//     });
//   }

//   // ── Observer ────────────────────────────────────────────────────────────
//   function initGiftBadgeObserver() {
//     const targets = [
//       '#halo-cart-sidebar', '.previewCart-wrapper',
//       '#main-cart-items', '[data-cart]', 'cart-items',
//       '.cart-container'
//     ].map(s => document.querySelector(s)).filter(Boolean);

//     if (!targets.length) return;

//     const observer = new MutationObserver(() => {
//       clearTimeout(window._giftBadgeTimer);
//       window._giftBadgeTimer = setTimeout(applyFreeGiftPriceDisplay, 100);
//     });

//     targets.forEach(el => observer.observe(el, { childList: true, subtree: true }));
//   }

  
//   // ── Intercept cart MUTATIONS ────────────────────────────────────────────
//   function interceptCartRequests() {
//     const originalFetch = window.fetch;

//     window.fetch = function(...args) {
//       const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

//       const isCartMutation =
//         (url.includes('/cart/change') ||
//          url.includes('/cart/update') ||
//          url.includes('/cart/add')) &&
//         !url.includes('view=');

//       const result = originalFetch.apply(this, args);

// if (isCartMutation && !_ownCartCall) {
//   toggleCheckoutButton(true);

//   result.then(res => {
//     if (res.ok) {
//       triggerGiftUpdate(350);
//     }
//   }).catch(() => {
//     toggleCheckoutButton(false);
//   });
// }

// return result;
//     };

//     const originalOpen = XMLHttpRequest.prototype.open;
//     const originalSend = XMLHttpRequest.prototype.send;

//     XMLHttpRequest.prototype.open = function(method, url, ...rest) {
//       this._cartUrl = url;
//       return originalOpen.apply(this, [method, url, ...rest]);
//     };

//     XMLHttpRequest.prototype.send = function(...args) {
//       const url = this._cartUrl || '';
//       const isCartMutation =
//         (url.includes('/cart/change') ||
//          url.includes('/cart/update') ||
//          url.includes('/cart/add')) &&
//         !url.includes('view=');

//       if (isCartMutation && !_ownCartCall) {
//         this.addEventListener('load', () => {
//           if (this.status >= 200 && this.status < 300) {
//             triggerGiftUpdate(350);
//           }
//         });
//       }

//       return originalSend.apply(this, args);
//     };
//   }

//   // ── Listen for cart-update event from theme ──────────────────────────────
//   function listenForThemeCartUpdates() {
//     document.addEventListener('cart-update', (e) => {
//       if (_ownCartCall || isUpdatingGift) return;
//       console.log('[GiftSystem] cart-update event received');
//       triggerGiftUpdate(350);
//     });
//   }

//   function listenForCartPageQuantityChanges() {
//     document.addEventListener('change', (e) => {
//       if (
//         e.target.matches(
//           'input[name="updates[]"], input.item-quantity, ' +
//           'input[data-quantity-input], input.quantity, ' +
//           '[data-cart-quantity], input[data-cart-quantity]'
//         ) && !_ownCartCall
//       ) {
//         toggleCheckoutButton(true); // Disable instantly
//         triggerGiftUpdate(400);
//       }
//     });
//     document.addEventListener('click', (e) => {
//       const removeBtn = e.target.closest(
//         '.cart-remove, [data-cart-remove], .cart-item__remove, .remove-item, .cart-item-block.cart-item-remove'
//       );

//       if (removeBtn && !_ownCartCall) {
//         toggleCheckoutButton(true); // Disable instantly
//         triggerGiftUpdate(400);
//       }
//     });

//     document.addEventListener('click', (e) => {
//       if (
//         e.target.matches(
//           '.quantity__button, .ajaxcart__qty-adjust, [data-quantity-plus], ' +
//           '[data-quantity-minus], .cart-item__quantity button, .qty-btn, ' +
//           '.quantity-btn, .btn-quantity, .quantity .plus, .quantity .minus'
//         ) && !_ownCartCall
//       ) {
//         triggerGiftUpdate(400);
//       }
//     });
//   }

//   // ── Expose globally ─────────────────────────────────────────────────────
//   window.triggerGiftUpdate = triggerGiftUpdate;
//   window.updateMultipleFreeGifts = updateMultipleFreeGifts;
//   window.refreshCartUI = refreshCartUI;
//   window.applyFreeGiftPriceDisplay = applyFreeGiftPriceDisplay;

//   // ── Init ─────────────────────────────────────────────────────────────────
//   document.addEventListener('DOMContentLoaded', async () => {
//     interceptCartRequests();
//     listenForCartPageQuantityChanges();
//     listenForThemeCartUpdates();
//     initGiftBadgeObserver();
//     await preCacheGiftVariants();
//     await updateMultipleFreeGifts();
//   });

//   document.addEventListener('cart:updated', (e) => {
//     if (e.detail && e.detail._source === 'giftSystem') return;
//     if (!_ownCartCall && !isUpdatingGift) triggerGiftUpdate(350);
//   });

//   document.addEventListener('ajaxCart:afterAddItem', () => {
//     if (!_ownCartCall && !isUpdatingGift) triggerGiftUpdate(350);
//   });

//   document.addEventListener('cart:item-removed', () => {
//     if (!_ownCartCall && !isUpdatingGift) triggerGiftUpdate(350);
//   });

// })();

async function checkBundleProductLimit() {
  const checkoutBtn = document.querySelector('.button-checkout');
  const CartMessageBundle = document.querySelector('.cart-message-bundle');

  // 🔒 ALWAYS START LOCKED (no flicker)
  if (checkoutBtn) {
    checkoutBtn.disabled = true;
    checkoutBtn.style.opacity = "0.5";
    checkoutBtn.style.pointerEvents = "none";
  }

  if (CartMessageBundle) {
    CartMessageBundle.style.display = "none";
  }

  const cart = await fetch('/cart.js').then(res => res.json());

  let bundleCount = 0;

  // 🔥 parallel fetch (fast + stable)
  const products = await Promise.all(
    cart.items.map(item =>
      fetch(`/products/${item.handle}.js`)
        .then(res => res.json())
        .catch(() => null)
    )
  );

  for (let i = 0; i < products.length; i++) {
    const product = products[i];
    const item = cart.items[i];

    if (product?.tags?.includes("bundle-product")) {
      bundleCount += item.quantity;
    }
  }

  console.log("Bundle count:", bundleCount);

  // ✅ FINAL DECISION ONLY ONCE
  if (bundleCount <= 1) {
    console.log("✅ Enable checkout");

    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = "1";
      checkoutBtn.style.pointerEvents = "auto";
    }
  } else {
    console.log("🚫 Stay disabled");

    if (CartMessageBundle) {
      CartMessageBundle.style.display = "block";
    }
  }
}

checkBundleProductLimit();
document.addEventListener("cart:updated", checkBundleProductLimit);